export enum HeaderTheme {
  White,
  Blue,
  Transparent,
}

export enum HeaderVariant {
  Dub,
  Full,
  Global,
}

export enum HeaderHeight {
  Small = '64px',
  Large = '80px',
}

export type BreakpointType = 'sm' | 'md' | 'lg';
